import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import useFetch from 'hooks/useFetch';
import { FETCH_SPECIES } from '../actions';
export const initialState = {
    loading: false,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: []
    },
    error: ''
};

export const fetchSpecies = createAsyncThunk(FETCH_SPECIES, (url) => {
    return url ? useFetch(url, false) : useFetch('species');
});

const speciesSlice = createSlice({
    name: 'species',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchSpecies.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(fetchSpecies.fulfilled, (state, action) => {
            state.loading = false;
            state.data.count = action.payload.data.count;
            state.data.next = action.payload.data.next;
            state.data.previous = action.payload.data.previous;
            state.data.results = state.data.results.concat(action.payload.data.results);
            state.error = '';
        });

        builder.addCase(fetchSpecies.rejected, (state, action) => {
            state.loading = false;
            state.data.results = [];
            state.error = action.error.message;
        });
    }
});

export default speciesSlice;
